module.exports = __webpack_public_path__ + "img/Newegg.672df926.jpg";